






import Vue from 'vue';
import { MobileUtil } from '@/web/util/MobileUtil';

const mobileUtil = new MobileUtil(window.navigator.userAgent);

export default Vue.component('Sticky', {
  name: 'Sticky',
  methods: {
    stickyCardClass() {
      if (mobileUtil.isMobile()) {
        return ' sticky-card-mobile ';
      }
      return ' sticky-card ';
    },
  },
});
